import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from "vue";
import { trans } from "laravel-vue-i18n";
import { format, parse } from "fecha";
import { useAuthStore } from "@/ts/stores/auth";


export default /*#__PURE__*/_defineComponent({
  emits: ["mounted"],
  setup(__props, { expose, emit }) {
  expose();

const component = ref<HTMLDivElement>();
const authStore = useAuthStore();



onMounted(() => {
    emit("mounted", component.value!.offsetHeight);

    onMounted(() => {
        window.addEventListener("resize", () => {
            emit("mounted", component.value!.offsetHeight);
        });

        window.addEventListener("orientationchange", () => {
            emit("mounted", component.value!.offsetHeight);
        });
    });
});

const daysLeft = computed(() => {
    const today = new Date();
    const Difference_In_Time = parse(authStore.user!.membership_end_date, "DD/MM/YYYY")!.getTime() - today.getTime();
    const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
    return Math.ceil(Difference_In_Days);
});

const __returned__ = { component, authStore, emit, daysLeft }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})